<template>
  <div class="box loan" v-if="bondedLoan">
    <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>

    <div class="page-header-wrapper logical-block">
      <div class="page-header translucent-wrapper" v-bind:style="headerStyle">
        <div class="centered">
          <b-switch v-model='loanObject.isHidden'>Скрыть страницу</b-switch>
        </div>

        <div class="centered">
          <span class="button-wrapper" @click="handleLoadLoanPhoto">
            <a class="button is-info">+</a>Загрузить фото
          </span>
        </div>
        
        <b-field>
            <b-input placeholder="Заголовок" v-model="loanObject.title"></b-input>
        </b-field>
        
        <b-field>
          <b-input placeholder="Текст" type="textarea"
            v-model="loanObject.description"></b-input>
        </b-field>
      </div>
    </div>

    <div class="logical-block">
      <div class="caption">
        <h2>Описание</h2>
      </div>

      <div class="loan-description page-header-wrapper">
        <div class="description-wrapper">
          <b-field>
            <b-input placeholder="Текст" v-model="loanObject.aboutTitle"
              class="p-option"></b-input>
          </b-field>

          <b-field>
            <Editor v-model="aboutDescription" :editorToolbar="customToolbar"
              v-bind:id="'aboutDescriptionEditor'" class="p-option color-black"
            />
          </b-field>
        </div>
      </div>
    </div>
    
    <div class="logical-block">
      <div class="caption">
        <h2>Преимущества</h2>
      </div>

      <div class="logical-block-content">
        <div class="description-wrapper">
          <b-field>
            <b-input placeholder="Заголовок" v-model="loanObject.advantagesTitle"
              class="p-option"></b-input>
          </b-field>
        </div>

        <div class="advantages">
          <Advantage v-for="advantage in loanObject.advantages" class="advantage-item"
            :key="advantage.id" :advantage="advantage"
          />

          <div class="centered" 
            v-if="loanObject.advantages && loanObject.advantages.length !== 2"
          >
            <span class="button-wrapper" @click="handleAddAdvantage">
              <a class="button is-info">+</a>Добавить преимущество
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="logical-block">
      <div class="caption">
        <h2>Письма</h2>
      </div>

      <div class="logical-block-content">
        <div class="description-wrapper">
          <b-field>
            <b-input placeholder="Заголовок блока" v-model="loanObject.lettersTitle"
              class="p-option"></b-input>
          </b-field>

          <b-field>
            <b-input placeholder="Надпись на кнопке 'показать еще'"
              v-model="loanObject.lettersBtnTitle" class="p-option"></b-input>
          </b-field>
        </div>

        <div class="advantages letters">
            <Letter v-for="letter in loanObject.letters" class="advantage-item"
              :key="letter.id" :letter="letter"
            />
          <div class="centered">
            <span class="button-wrapper" @click="handleAddLetter">
              <a class="button is-info">+</a>Добавить письмо
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="caption">
      <h2>Акция, соответствующая услуге</h2>
      <span>Чтобы добавить акцию перейдите в меню "Акции"</span>
    </div>
    <div class="promo-wrapper is-flex">
      <el-select
        v-model="selectedPromo"
        placeholder="Выбрать акцию"
        @change="changePromo"
        class="p-option"
        clearable
      >
        <el-option
          v-for="promo in servicePromos"
          :key="promo.id"
          :label="promo.title"
          :value="promo.id">
        </el-option>
      </el-select>
    </div>

    <div class="save-content-button centered">
      <button class="button save-content" @click="handleSaveLoan()" :disabled="disabled">
        {{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import deepcopy from 'deepcopy'
  import uuidv4 from 'uuid/v4'

  import { VueEditor as Editor } from 'vue2-editor'

  import Advantage from './Advantage'
  import Letter from './Letter'

  export default {
    name: 'BondedLoan',

    data () {
      return {
        base64photo: '',
        disabled: false,
        customToolbar: [
          ['bold', 'italic', 'underline'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          ['link']
        ],
        aboutDescription: '',
        selectedPromo: null
      }
    },

    computed: {
      ...mapState(['bondedLoan', 'servicePromos']),
      loanObject () {
        this.aboutDescription = this.bondedLoan.aboutDescription
        return deepcopy(this.bondedLoan)
      },

      headerStyle () {
        if (this.loanObject.photo || this.base64photo) {
          if (!this.base64photo.length) {
            return { background: `url(/upload/photos/${this.bondedLoan.photo})` }
          } else {
            return {background: `url(${this.base64photo})`}
          }
        } else {
          return {background: ''}
        }
      }
    },

    methods: {
      ...mapActions(['getBondedLoan', 'loadBondedLoanPhoto', 'addBondedLoanAdvantage',
        'updateBondedLoanAdvantagesOrder', 'saveBondedLoan', 'getPromosForServices',
        'addBondedLoanLetter', 'updateBondedLoanLettersOrder']),

      loadPhoto (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (ee) => {
          this.base64photo = ee.target.result
          this.$forceUpdate()
        }
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        this.loanObject.newPhoto = formData
      },

      changePromo (value) {
        this.loanObject.promo_id = value !== '' ? value : null
      },

      handleLoadLoanPhoto () {
        this.$refs.loadPhotoButton.click()
      },

      handleAddAdvantage () {
        if (this.loanObject.advantages.length < 2) {
          this.addBondedLoanAdvantage({
            order: this.loanObject.advantages.length,
            title: '',
            description: '',
            videoPreview: '',
            videoLink: '',
            buttonLink: '',
            buttonTitle: 'ПОДРОБНЕЕ',
            bondedLoanId: this.loanObject.id,
            id: uuidv4()
          })
          this.$forceUpdate()
        }
      },

      handleAddLetter () {
        if (this.loanObject.letters) {
          this.addBondedLoanLetter({
            order: this.loanObject.letters.length,
            type: 'pdf',
            file: '',
            preview: '',
            id: uuidv4(),
            bondedLoanId: this.loanObject.id,
            title: ''
          })
          this.$forceUpdate()
        }
      },

      handleSaveLoan () {
        this.disabled = true
        this.saveBondedLoan(this.loanObject)
          .then(() => {
            this.disabled = false
            this.$toast.open({ message: 'Сохранено' })
          })
      }
    },

    created () {
      this.getBondedLoan()
      this.getPromosForServices()
    },

    watch: {
      aboutDescription () {
        this.loanObject.aboutDescription = this.aboutDescription
      },
      bondedLoan (val) {
        this.selectedPromo = val.promo_id ? val.promo_id : null
      }
    },

    components: { Editor, Advantage, Letter }
  }
</script>

<style>
.loan {
  width: calc(100% - 200px);
  display: flex;
  flex-direction: column;
}

.loan-description {
  margin: 0 auto;
  position: relative;
  background: #eeeeee;
  display: block !important;
}

.page-header-wrapper {
  background-size: cover !important;
  background-position: center !important;
}

.page-header {
  margin: 0 auto;
}

.p-option {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
}

.description-wrapper {
  padding: 30px 20px;
}

.caption {
  text-align: center;
  margin: 20px 0;
}

.gray-wrapper {
  /* background: #eeeeee; */
  padding: 20px 20px;
}

.logical-block {
  margin-bottom: 40px;
}
.logical-block-content {
  background-color: #eeeeee;
  padding-bottom: 30px;
}

.advantage-item {
  margin-bottom: 30px;
}
.advantage-item:last-child {
  margin-bottom: 0;
}

.promo-wrapper {
  margin-bottom: 50px;
}

.letters {
  padding-top: 40px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?57f9c6bc